import { render, staticRenderFns } from "./globalInvoice.vue?vue&type=template&id=30351314"
import script from "./globalInvoice.vue?vue&type=script&lang=js"
export * from "./globalInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports